import styled from 'styled-components';

export const Form = styled.form`
  display: block;
  max-width: 60%;

  @media (max-width: 480px) {
    max-width: 100%;

    & button[type='submit'] {
      width: 100% !important;
    }
  }
`;
